import React, { Component } from 'react';
import { classname, openOrderPopup } from 'utils';
import './Company.css';

const AWARDS = [
  { place: '1 место', text: 'Workspace Digital Awards в\u00A0категории «Дизайн и\u00A0брендинг. Упаковка и\u00A0этикетка»' },
  { place: '1 место', text: 'Tagline Awards в\u00A0категории «Лучшее поисковое продвижение»' },
  { place: '2 место', text: 'Tagline Awards в\u00A0категории «Лучший сайт о\u00A0промышленности»' },
  { place: '3 место', text: 'Рейтинг Рунета «ИТ: Облачные технологии и\u00A0дата-центры»' },
  { place: '6 место', text: 'Рейтинг Рунета «Подрядчики еком-компаний: Коммуникации»' },
  { place: '3 место', text: 'Рейтинг Рунета «Металлургия: Производство, обработка»' },
  { place: '2 место', text: 'Tagline Awards в\u00A0категории «Лучшая b2b-кампания»' },
  { place: '2 место', text: 'Tagline Awards «Лучшая кампания для\u00A0телеком— / IT— / интернет-бизнеса»' },
];

const WHY_CARDS = [
  {
    title: 'Система вместо набора услуг',
    text: 'Брендинг, разработка и\u00A0продвижение сайтов, интернет-маркетинг (продвижение в\u00A0социальных сетях, поисковое продвижение, контекстная реклама) связаны едиными правилами с\u00A0общими показателями эффективности.',
    icon: '/company/why-1.png',
  },
  {
    title: 'Инженерная управляемость',
    text: 'Ценим ваше время. За 12\u00A0недель передаём платформу бренда, дизайн-систему, контент и\u00A0медиа-план.',
    icon: '/company/why-2.png',
  },
  {
    title: 'Премиальный сервис',
    text: 'Ограничение на\u00A0количество активных проектов, персональные руководители направлений, регламент по\u00A0срокам и\u00A0взаимодействию.',
    icon: '/company/why-3.png',
  },
  {
    title: 'Честная коммуникация',
    text: 'Работаем на\u00A0результат. Если задача не\u00A0решает цели бизнеса\u00A0— говорим открыто. Если нужно изменить подход\u00A0— предлагаем варианты и\u00A0обсуждаем.',
    icon: '/company/why-4.png',
  },
];

const BUSINESS_CARDS = [
  {
    title: 'Чёткая бренд-система',
    text: 'Позиционирование, стиль коммуникации, визуальная концепция и\u00A0единые правила для\u00A0всех коммуникаций.',
    img: '/company/why-2.png',
  },
  {
    title: 'Готовые инструменты',
    text: 'Дизайн-система, сайт или\u00A0лендинг, контент-пак и\u00A0медиаматериалы.',
    img: '/company/why-5.png',
  },
  {
    title: 'Запущенные каналы роста',
    text: 'Стратегия поискового продвижения (SEO) под\u00A0нишевые запросы, контент-модель, работающие сообщества, контекстная реклама и\u00A0продвижение в\u00A0социальных сетях (SMM).',
    img: '/company/why-6.png',
  },
];

const STEPS = [
  { num: '01', title: <>Диагностика<br />{'и\u00A0цель'}</>, text: 'Проводим аудит, фиксируем бизнес-результаты и\u00A0ограничения.' },
  { num: '02', title: <>Проектирование<br />системы</>, text: 'Создаём платформу бренда, дизайн-систему, контент и\u00A0медиа-план.' },
  { num: '03', title: <>Запуск<br />{'и\u00A0перформанс'}</>, text: 'Синхронно запускаем сайт, поисковое продвижение (SEO), контекстную рекламу, продвижение в\u00A0социальных сетях (SMM) и\u00A0креатив.' },
  { num: '04', title: <>Измерение<br />{'и\u00A0масштабирование'}</>, text: 'Тестируем гипотезы, проводим A/B-тесты, отслеживаем общие показатели эффективности и\u00A0развиваем то,\u00A0что работает.' },
];

const STANDARDS = [
  {
    title: 'SLA по\u00A0коммуникации',
    text: 'Ответ в\u00A0рабочие часы, еженедельные встречи по\u00A0статусу проекта, ежемесячные стратегические сессии, оценка удовлетворённости клиентов и\u00A0поддержка после\u00A0запуска.',
  },
  {
    title: 'Качество и\u00A0скорость',
    text: 'Ограничиваем количество активных проектов, чтобы держать планку эффективности.',
  },
  {
    title: 'Формат работы',
    text: 'Статусы\u00A0— каждую неделю, презентация отчётов\u00A0— каждый месяц, аудит качества менеджмента\u00A0— каждый квартал.',
  },
];

class Company extends Component {
  cl = classname('company');

  render() {
    return (
      <div className={this.cl()}>

        {/* Hero */}
        <section className={this.cl('hero')}>
          <img className={this.cl('hero-bg')} src="/company/hero-bg.jpg" alt="" aria-hidden="true" />
          <div className={this.cl('hero-content')}>
            <h1 className={this.cl('hero-title')}>
              Создаём опыт бренда<br />для технологичных компаний
            </h1>
            <p className={this.cl('hero-sub')}>
              {'Nimax\u00A0— диджитал-агентство полного цикла. Создаём комплексный маркетинг и\u00A0проектируем бренды как\u00A0единую систему.'}
            </p>
          </div>
        </section>

        {/* Tagline */}
        <section className={this.cl('tagline')}>
          <p className={this.cl('tagline-text')}>
            <span className={this.cl('tagline-accent')}>{'Стратегия, брендинг, креатив, коммуникации и\u00A0перформанс-маркетинг'}</span>
            {' становятся одним управляемым контуром, а\u00A0сложные продукты\u00A0— понятными, желанными и\u00A0измеримо эффективными.'}
          </p>
        </section>

        {/* Image band */}
        <section className={this.cl('image-band')}>
          <div className={this.cl('image-band-track')}>
            {[...Array(2)].map((_, rep) =>
              [1,2,3,4,5,6,7].map(n => (
                <img
                  key={`${rep}-${n}`}
                  className={this.cl('image-band-item')}
                  src={`/company/why-${n}.png`}
                  alt=""
                  aria-hidden="true"
                />
              ))
            )}
          </div>
        </section>

        {/* Stats */}
        <section className={this.cl('stats')}>
          <h2 className={this.cl('section-title')}>{'Цифры и\u00A0факты о\u00A0нас'}</h2>
          <div className={this.cl('stats-grid')}>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>25+</div>
              <div className={this.cl('stat-label')}>{'лет в\u00A0индустрии'}</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>70+</div>
              <div className={this.cl('stat-label')}>{'специалистов в\u00A0команде'}</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>Отрасли</div>
              <div className={this.cl('stat-label')}>{'Работаем с\u00A0технологическими компаниями, сферой финансовых технологий, промышленными компаниями и\u00A0интернет-магазинами'}</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>Основатели</div>
              <div className={this.cl('stat-founders')}>
                <div className={this.cl('founders-photos')}>
                  <img src="/company/founder-1.png" alt="Никита Михеенков" />
                  <img src="/company/founder-2.png" alt="Максим Коновалов" />
                </div>
                <div className={this.cl('stat-label')}>{'Никита Михеенков и\u00A0Максим Коновалов'}</div>
              </div>
            </div>
          </div>
        </section>

        {/* Awards */}
        <section className={this.cl('awards')}>
          <div className={this.cl('awards-header')}>
            <h2 className={this.cl('section-title')}>{'Награды и\u00A0партнёрства'}</h2>
            <p className={this.cl('awards-sub')}>
              {'Nimax\u00A0— сертифицированный партнёр Яндекс.Рекламы, аккредитованный партнёр myTarget и\u00A0Еламы, победитель рейтингов и\u00A0фестивалей рекламы, постоянный спикер профильных конференций.'}
            </p>
          </div>
          <div className={this.cl('awards-ticker-wrap')}>
            <div className={this.cl('awards-ticker')}>
              {[...AWARDS, ...AWARDS].map((a, i) => (
                <div key={i} className={this.cl('award-item')}>
                  <div className={this.cl('award-place')}>{a.place}</div>
                  <div className={this.cl('award-text')}>{a.text}</div>
                </div>
              ))}
            </div>
            <div className={this.cl('awards-ticker', { reverse: true })}>
              {[...AWARDS, ...AWARDS].map((a, i) => (
                <div key={i} className={this.cl('award-item')}>
                  <div className={this.cl('award-place')}>{a.place}</div>
                  <div className={this.cl('award-text')}>{a.text}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Nimax */}
        <section className={this.cl('why')}>
          <h2 className={this.cl('section-title')}>Почему выбирают Nimax</h2>
          <div className={this.cl('why-grid')}>
            {WHY_CARDS.map((card, i) => (
              <div key={i} className={this.cl('why-card')}>
                <div className={this.cl('why-card-top')}>
                  <h3 className={this.cl('why-card-title')}>{card.title}</h3>
                  <p className={this.cl('why-card-text')}>{card.text}</p>
                </div>
                <img className={this.cl('why-card-icon')} src={card.icon} alt="" aria-hidden="true" />
              </div>
            ))}
          </div>
        </section>

        {/* Clients logo ticker */}
        <section className={this.cl('clients')}>
          <div className={this.cl('clients-track')}>
            {[...Array(2)].map((_, rep) =>
              [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25].map(n => (
                <div
                  key={`${rep}-${n}`}
                  className={this.cl('clients-logo')}
                  style={{
                    WebkitMaskImage: `url(/logos/client_logo_${n}.svg)`,
                    maskImage: `url(/logos/client_logo_${n}.svg)`,
                  }}
                  aria-hidden="true"
                />
              ))
            )}
          </div>
        </section>

        {/* Business results */}
        <section className={this.cl('business')}>
          <h2 className={this.cl('section-title')}>{'Что получит бизнес за\u00A090 дней'}</h2>
          <div className={this.cl('business-grid')}>
            {BUSINESS_CARDS.map((card, i) => (
              <div key={i} className={this.cl('business-card')}>
                <h3 className={this.cl('business-card-title')}>{card.title}</h3>
                <p className={this.cl('business-card-text')}>{card.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* How we work */}
        <section className={this.cl('how')}>
          <h2 className={this.cl('section-title')}>{'Как мы подходим к\u00A0работе'}</h2>
          <div className={this.cl('how-grid')}>
            {STEPS.map((step) => (
              <div key={step.num} className={this.cl('how-step')}>
                <div className={this.cl('how-step-top')}>
                  <h3 className={this.cl('how-step-title')}>{step.title}</h3>
                  <p className={this.cl('how-step-text')}>{step.text}</p>
                </div>
                <div className={this.cl('how-step-num')}>{step.num}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Fit or not */}
        <section className={this.cl('fit')}>
          <h2 className={this.cl('section-title')}>В каких случаях мы подойдём друг другу</h2>
          <div className={this.cl('fit-cols')}>
            <div className={this.cl('fit-col')}>
              <div className={this.cl('fit-label')}>Сработаемся, если</div>
              <ul className={this.cl('fit-list')}>
                <li>нужна консистентная система: стратегия → бренд → сайт → SEO/SMM/контекст</li>
                <li>{'важны прозрачные процессы и\u00A0прогнозируемые результаты'}</li>
                <li>{'готовы работать по\u00A0метрикам и\u00A0быстрым итерациям'}</li>
              </ul>
            </div>
            <div className={this.cl('fit-col')}>
              <div className={this.cl('fit-label')}>Не подойдём, если</div>
              <ul className={this.cl('fit-list')}>
                <li>{'ищете решение небольшой разовой задачи или\u00A0дизайн без\u00A0стратегии'}</li>
                <li>{'не\u00A0планируете измерять эффект и\u00A0менять процессы'}</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Partners */}
        <section className={this.cl('partners')}>
          <div className={this.cl('partners-left')}>
            <h2 className={this.cl('section-title')}>{'Работаем с\u00A0партнёрами'}</h2>
          </div>
          <div className={this.cl('partners-right')}>
            <p>{'Если наши условия работы\u00A0— не\u00A0совсем то,\u00A0что вы ищете,\u00A0— ничего страшного. У нас большая партнёрская сеть, в\u00A0которой найдётся подходящий исполнитель. Мы работаем в\u00A0одной экосистеме с\u00A0проверенными экспертами, которым доверяем.'}</p>
            <p>{'Подберём подрядчика под\u00A0вашу сферу, масштаб, локацию и\u00A0бюджет. Останемся на\u00A0связи и\u00A0при необходимости подключимся к\u00A0проекту.'}</p>
            <button type={'button'} onClick={() => openOrderPopup()} className={this.cl('partners-btn')}>Оставить заявку</button>
          </div>
        </section>

        {/* Team */}
        <section className={this.cl('team')}>
          <div className={this.cl('team-top')}>
            <div className={this.cl('team-left')}>
              <h2 className={this.cl('section-title')}>Команда</h2>
            </div>
            <div className={this.cl('team-right')}>
              <p className={this.cl('team-text')}>
                {'Стратеги, дизайнеры и\u00A0перформанс-маркетологи\u00A0— мы уделяем много времени, чтобы сформировать команду. Каждый проект ведёт персональный менеджер, а\u00A0процессы прозрачны для\u00A0клиента.'}
              </p>
              <a href="/jobs/" className={this.cl('team-link')}>
                <svg aria-hidden="true" className={this.cl('team-link-icon')} width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="miter"/>
                </svg>
                {'Карьера в\u00A0Nimax'}
              </a>
            </div>
          </div>
          <div className={this.cl('team-photo-wrap')}>
            <img className={this.cl('team-photo')} src="/company/team.jpg" alt="Команда Nimax" />
          </div>
        </section>

        {/* Standards */}
        <section className={this.cl('standards')}>
          <h2 className={this.cl('section-title')}>Стандарты сервиса Nimax</h2>
          <div className={this.cl('standards-grid')}>
            {STANDARDS.map((s, i) => (
              <div key={i} className={this.cl('standard')}>
                <h3 className={this.cl('standard-title')}>{s.title}</h3>
                <p className={this.cl('standard-text')}>{s.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Founder */}
        <section className={this.cl('founder')}>
          <div className={this.cl('founder-inner')}>
            <img
              className={this.cl('founder-photo')}
              src="/company/mikheenkov.png"
              alt="Никита Михеенков"
            />
            <div className={this.cl('founder-content')}>
              <h2 className={this.cl('founder-name')}>Никита Михеенков</h2>
              <p className={this.cl('founder-text')}>
                Сооснователь Nimax, предприниматель и автор Telegram-канала «Сломай и сделай нормально». Делится тем, как развивается агентство изнутри: управлением командой, запуском новых направлений, внедрением ИИ в процессы, поиском точек роста и взглядом на изменения digital-рынка. Если хотите лучше понять наш подход к работе и принципы, по которым мы строим проекты — начните с его материалов.
              </p>
              <div className={this.cl('founder-links')}>
                <a
                  className={this.cl('founder-link')}
                  href="https://t.me/mikheenkovnews"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg aria-hidden="true" className={this.cl('founder-link-icon')} width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="miter"/>
                  </svg>
                  Читать Telegram-канал
                </a>
                <a
                  className={this.cl('founder-link')}
                  href="https://mikheenkov.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg aria-hidden="true" className={this.cl('founder-link-icon')} width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="miter"/>
                  </svg>
                  Перейти на сайт
                </a>
              </div>
            </div>
          </div>
        </section>

      </div>
    );
  }
}

export default Company;
